export class SubscriptionFilter {
    public eventName: string;
    public folderId: number;
    public formInstanceId: number;
    public discriminator: string;

    public constructor(discriminator: string) {
        this.discriminator = discriminator;
    }
}
